import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Badge, NewNotificationBadge, NewContentsBadge, LabelWrapper, Wrapper, Content, Image, DefaultImage } from './styledComponents.mjs';
import { getRandomColorOfLetter } from '../../helpers/getRandomColorOfLetter.mjs';
import { useHover } from '../../hooks/useHover.mjs';
import { hex2RGBA } from '../../theme/helpers/hexToRgba.mjs';
import * as React from 'react';

var GroupProfileImage = /*#__PURE__*/React.memo(function (props) {
  var size = props.size,
    title = props.title,
    icon = props.icon,
    badge = props.badge,
    hasNewNotification = props.hasNewNotification,
    hasNewContents = props.hasNewContents,
    selected = props.selected,
    useHoverStyle = props.useHoverStyle,
    onImageClick = props.onImageClick,
    styles = props.styles;
  var _useHover = useHover(),
    _useHover2 = _slicedToArray(_useHover, 2),
    hoverRef = _useHover2[0],
    hovered = _useHover2[1];
  var isTextIcon = (icon === null || icon === void 0 ? void 0 : icon.type) === "text" || !icon;
  var textIcon = React.useMemo(function () {
    return (icon === null || icon === void 0 ? void 0 : icon.type) === "text" ? Object.assign(Object.assign({}, icon.data), {
      color: hex2RGBA(icon.data.color),
      bg_color: hex2RGBA(icon.data.bg_color)
    }) : {
      color: getRandomColorOfLetter(props.title),
      bg_color: getRandomColorOfLetter(props.title),
      text: props.title.charAt(0)
    };
  }, [icon, props.title]);
  var badgeElement = React.useMemo(function () {
    if (selected) {
      return null;
    }
    if (badge) {
      return jsx(Badge, {
        children: badge
      });
    } else if (hasNewNotification) {
      return jsx(NewNotificationBadge, {});
    } else if (hasNewContents) {
      return jsx(NewContentsBadge, {});
    }
    return null;
  }, [badge, hasNewContents, hasNewNotification, selected]);
  return /*#__PURE__*/React.createElement(selected ? LabelWrapper : Wrapper, {
    size: size,
    styles: styles,
    selected: selected,
    hovered: useHoverStyle && hovered,
    ref: hoverRef
  }, jsxs(Fragment, {
    children: [jsx(Content, {
      style: {
        backgroundColor: isTextIcon ? textIcon.bg_color : undefined
      },
      children: (icon === null || icon === void 0 ? void 0 : icon.type) === "image" ? icon.data.url ? jsx(Image, {
        src: icon.data.url,
        alt: title,
        onClick: onImageClick
      }) : jsx(DefaultImage, {
        onClick: onImageClick,
        size: size
      }) : textIcon.text
    }), badgeElement]
  }));
});

export { GroupProfileImage };
